import { Theme } from '@chakra-ui/react'

import { DeepPartial } from '../../../common/types'

import { Button } from './Button'
import { Input } from './Input'
import { Progress } from './Progress'
import { Alert } from './Alert'

export interface NucbaComponentsTheme
  extends DeepPartial<Theme['components']> {}

export const components: NucbaComponentsTheme = {
  Button,
  Input,
  Progress,
  Alert,
}
